var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"btn-list"},_vm._l((_vm.footerBtnList),function(item,index){return _c('div',{key:index,staticClass:"btn-item",class:_vm.activePage === item.page && 'active',on:{"click":function($event){return _vm.handleFooterClick(item.page)}}},[_vm._v(_vm._s(item.label))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }